import { useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { Menu, Button, MenuItem, Typography } from '@mui/material';
// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const SORT_BY_OPTIONS = [
  { value: 'asc', label: 'Ascending' },
  { value: 'desc', label: 'Descending' },
];

export default function ListSort({  onRequestSort,setOrder}) {
  const [open, setOpen] = useState(null);
  const [selected,setSelected]=useState("asc")

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = (option) => {
    setOpen(null);
    setSelected(option)
  };

  const handleSort=(value)=>{
         if(value==="asc"){
          setOrder("asc")
         }else{
          setOrder("desc")
         }
         handleClose(value)
  }
  // eslint-disable-next-line
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);

  };

  return (
    <>
      <Button
        color="inherit"
        disableRipple
        onClick={handleOpen}
        endIcon={<Iconify icon={open ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} />}
      >
        Sort By:&nbsp;
        <Typography component="span" variant="subtitle2" sx={{ color: 'text.secondary' }}>
          select
        </Typography>
      </Button>
      <Menu
        keepMounted
        anchorEl={open}
        open={Boolean(open)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        // onClick={createSortHandler("name")}
      >
        {SORT_BY_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === selected }
            onClick={()=>handleSort(option.value)}
            sx={{ typography: 'body2' }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

ListSort.propTypes = {
  setOrder:PropTypes.any,
  onRequestSort:PropTypes.func
  };